import styled from 'styled-components';

export const Wrapper = styled.div``;
export const ContentWrapper = styled.div`
	ul {
		color: inherit;
		font-size: inherit;
		li {
			&:before {
				content: '';
				position: absolute;
				left: -2rem;
				top: 0.6rem;
				height: 6px;
				width: 6px;
				border-radius: 100%;
				background-color: ${props => props.theme.colors.primary};
			}
		}
	}
	p {
		margin-bottom: 0px;
	}
	margin-top: 2rem;
	.cs73C1CD47 {
		font-weight: bold;
		color: black;
	}
`;
